import React from "react";
import { ShieldCheck, Lock, Eye, Server, FileCheck2, Activity } from "lucide-react";
import "./LegalPages.css";

export default function Security() {
  const items = [
    {
      icon: <ShieldCheck size={26} />,
      title: "Role-Based Access Control",
      text: "Administrators, teachers, staff and parents only access information relevant to their assigned role and school relationship.",
    },
    {
      icon: <Lock size={26} />,
      title: "Multi-Factor Authentication",
      text: "PresentPlus supports MFA verification, session tracking, login monitoring and suspicious activity visibility.",
    },
    {
      icon: <Eye size={26} />,
      title: "Audit Visibility",
      text: "Administrative actions, evidence access, attendance submissions and invite actions are logged for accountability.",
    },
    {
      icon: <Server size={26} />,
      title: "Infrastructure Security",
      text: "Built on secure cloud infrastructure with encrypted transmission, protected authentication and resilient hosting.",
    },
    {
      icon: <FileCheck2 size={26} />,
      title: "Evidence Protection",
      text: "Sensitive evidence workflows are designed with controlled preview access and secure retention logic.",
    },
    {
      icon: <Activity size={26} />,
      title: "Incident Readiness",
      text: "Lockdown and monitoring workflows help schools respond quickly during sensitive operational events.",
    },
  ];

  return (
    <div className="pp-legal-page">
      <div className="pp-container">
        <div className="pp-legal-shell">
          <div className="pp-legal-hero">
            <div className="pp-legal-badge">Security & Trust</div>
            <h1>Enterprise-grade protection for modern schools</h1>
            <p>
              PresentPlus is designed with security, safeguarding, privacy and operational resilience at its core.
            </p>
          </div>

          <div className="pp-legal-grid">
            {items.map((item) => (
              <div className="pp-legal-card" key={item.title}>
                <div className="pp-legal-icon">{item.icon}</div>
                <h2>{item.title}</h2>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
